import type {CreateInventoryPlot} from '@/domain/entities/Op';
import type {OpRepository} from '@/domain/interfaces/OpRepository';

export class OpCreateInventoryPlot {
  constructor(private readonly repository: OpRepository) {}
  execute = async (domain: CreateInventoryPlot, file: File) => {
    await this.repository.createInventoryPlots(domain, file);
  };
}
